import { combineReducers } from "redux";

// Front
import Layout from "./layouts/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Register from "./auth/register/reducer";
import Account from "./auth/register/reducer";
import User from "./user/reducer";
import Role from "./role/reducer";
import Dashboard from "./dashboard/reducer";
import Client from "./client/reducer";
import Device from "./device/reducer";
// import DeviceType from "./deviceType/reducer";
// import Parameter from "./parameter/reducer";
// import Unit from "./unit/reducer";
// import Address from "./address/reducer";
// import Folder from "./folder/reducer";
// import File from "./file/reducer";
// import Sensor from "./sensor/reducer";
import History from "./history/reducer";
// import ReportTemplate from "./reportTemplate/reducer";
// import ReportTemplateDetail from "./reportTemplateDetail/reducer";
// import Uom from "./uom/reducer";
// import Company from "./company/reducer";
// import Branch from "./branch/reducer";
// import DashboardTemplate from "./dashboardTemplate/reducer";
// import DashboardTemplateDetail from "./dashboardTemplateDetail/reducer";
// import Notification from "./notification/reducer";

const rootReducer = combineReducers({
  Layout,
  Login,
  Dashboard,
  User,
  Role,
  Account,
  Client,
  Register,
  Device,
  // DeviceType,
  // Unit,
  // Address,
  // Folder,
  // File,
  // Parameter,
  // Sensor,
  History,
  // ReportTemplate,
  // ReportTemplateDetail,
  // Uom,
  // Company,
  // Branch,
  // DashboardTemplate,
  // DashboardTemplateDetail,
  // Notification,
});

export default rootReducer;
